import SectionInterface from "../interfaces/SectionInterface";

// AIアシスタントサマリー一覧・プロンプト設定画面へのアクセス可否（ACC-01 / ACC-02）。
// サイドバー導線の出しわけと直接 URL アクセスガードはこの判定を共有する。
export const isStudentFollowSummaryAccessible = (
  section: SectionInterface,
): boolean => {
  return !!section.aiAssistantAvailable;
};
